// extracted by mini-css-extract-plugin
module.exports = {"details":"details__2hA77","no-subscriptions":"no-subscriptions__3_LhL","fade-in":"fade-in__2dQWf","label":"label__QoyUI","text":"text__3BYft","notice":"notice__2RKDr"};